import React from 'react'
import Footer from '../components/Footer/Footer';
import './styles.css';

import B2BLead from '../assets/leadgeneration.png';

import ScrollToTop from '../components/ScrollToTop';
import PageNav from '../components/PageNav/PageNav';

const LeadGen = () => {
  return (
    <div>
        <ScrollToTop />
        <PageNav />
        <section className="main-section">
          <div className="page-container">
              <div className="page-title">
                <h1>B2B Lead Generation</h1>
              </div>    
                      
              <div className="des-title-text">
                  <span>Unlock the potential of your business with WebHarvester Agency's expert B2B lead generation services. We specialize in providing you with high-quality B2B leads, email lists, LinkedIn leads, and prospect lists customized to your unique requirements. Our dedicated team harnesses the power of top-tier tools, including LinkedIn Sales Navigator, ZoomInfo, Dun & Bradstreet (DNB), Crunchbase, and other business directories, to connect you with the right prospects.</span>
                </div>

            <div className="page-content">
              <div className="page-image">
                <img src={B2BLead} alt="" loading='lazy' />
              </div>
              
              <div className="page-description">
                <div className="des-middle-text">
                  <h3>What We Offer:</h3>
                  <div className="break-middle">
                    <span className="bold">🎯 Targeted Industry/Business: </span><span>Tell us your specific industry or business niche, and we'll tailor our lead generation efforts accordingly.</span>                  
                  </div>

                  <div className="break-middle">
                    <span className="bold">🌍 Targeted Country or City: </span><span>Whether you're looking to expand globally or locally, we'll focus on the regions that matter most to you.</span>                
                  </div>

                  <div className="break-middle">
                    <span className="bold">👤 Targeted Job Title: </span><span>Specify the job titles of the decision-makers or key contacts you want to reach.</span>           
                  </div>
                </div>

                <div className="des-middle-text">
                  <h3>What You Get:</h3>

                  <div className="break-middle">
                    <span className="bold">✅ Business Name: </span><span>Identify the businesses you want to connect with.</span>           
                  </div>

                  <div className="break-middle">
                    <span className="bold">🌐 Website: </span><span>Access valuable online information about your prospects.</span>           
                  </div>

                  <div className="break-middle">
                    <span className="bold">👥 First & Last Name: </span><span>Connect with individuals within the organizations.</span>           
                  </div>

                  <div className="break-middle">
                    <span className="bold">📧 Business Email Address: </span><span>Reach out directly to key contacts.</span>           
                  </div>

                  <div className="break-middle">
                    <span className="bold">📌 LinkedIn URL: </span>       <span>Expand your professional network on LinkedIn.</span>           
                  </div>

                  <div className="break-middle">
                    <span className="bold">📞 Business Phone Number: </span><span>Establish direct communication.</span>           
                  </div>

                  <div className="break-middle">
                    <span className="bold">🏢 Address: </span><span>Know where your prospects are located.</span>           
                  </div>

                  <div className="break-middle">
                    <span className="bold">📊 Any Required Information: </span><span>We're flexible and can provide additional information per your needs.</span>           
                  </div>
                </div>
              </div>
            </div>
                <div className="des-title-text">
                  <span>When you partner with WebHarvester Agency, you're choosing a team dedicated to delivering accurate, up-to-date, and relevant leads to fuel your business growth. We do the heavy lifting, so you can focus on converting leads into valuable opportunities. Contact us today, and let's start building your pipeline of potential clients and partners!</span>
                </div>

                <div className="main-btn">
                  <a href="https://www.fiverr.com/s/RvYKZ8" target='blank'>Order Now</a>
                </div>
          </div>
        </section>
        <Footer />
    </div>
  )
}

export default LeadGen;